// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_2pq7","input":"_2YY1"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Files/FileInput/FileInput.scss
// module id = WiFV
// module chunks = 0